<template>
  <v-snackbar
    location="left bottom"
    class="fontlao"
    v-model="dialog"
    color="success"
    right
  >
    ສໍາເລັດແລ້ວ
  </v-snackbar>
</template>

<script>
export default {
  computed: {
    dialog: {
      set(val) {
        this.$store.commit("snackbarSuccess", val);
      },
      get() {
        return this.$store.state.snackbarSuccess;
      },
    },
  },
};
</script>

<style></style>
